<template>
    <div class="alkohole">
        <ul>
            <li>-ol</li>
            <li>Hydroxy(l)-Gruppe</li>
            <li>polare funktionelle Gruppe</li>
            <li>bildet H-Brücken</li>
            <li>
                Oxidationen:
                <ul>
                    <li>prim. Alkohol => Aldehyd</li>
                    <li>sek. Alkohol => Keton</li>
                    <li>tert. Alkohol => nicht möglich!</li>
                </ul>
            </li>
        </ul>
        <img
            src="@/assets/img/stoffe/alkohole/1-2-3.jpg"
            alt="Drei Alkohol-Gruppen"
            title="Drei Alkohol-Gruppen"
        />
    </div>
</template>

<script>
export default {
    name: 'alkohole',
};
</script>
